














































































































import Component, { mixins } from 'vue-class-component';
import { loadWidget } from '@/utils/helpers';
import { namespace } from 'vuex-class';
import { IUssdSession } from '@/types/types';
import { Watch } from 'vue-property-decorator';
import WidgetMixins from '@/mixins/WidgetMixins';
import DialogMixins from '@/mixins/DialogMixins';
import qs from 'qs';

const ussdModule = namespace('ussdAdmin');

@Component({
  name: 'UssdSessions',
  components: {
    InternetConnection: loadWidget('pages/InternetConnection'),
    ToolBar: loadWidget('widgets/ToolBar'),
    SnackBar: loadWidget('widgets/SnackBar'),
    EmptyPage: loadWidget('pages/EmptyPage'),
  },
})
export default class UssdSessions extends mixins(WidgetMixins, DialogMixins) {
  @ussdModule.Getter('getSessions') sessions!: IUssdSession[];

  query: string = '';
  msisdn: string = '';
  serviceCode: string = '';

  headers: Array<{ text: string; value: string; sortable?: boolean }> = [
    { text: 'Session ID', value: 'sessionId' },
    { text: 'MSISDN', value: 'msisdn' },
    { text: 'Service Code', value: 'serviceCode' },
    { text: 'Callback URL', value: 'callbackUrl' },
    { text: 'Expires In', value: 'expiresInSeconds' },
    { text: '', value: 'actions', sortable: false },
  ];

  formatExpiry(seconds: number): string {
    if (seconds === null || seconds === undefined || seconds < 0) return 'unknown';
    if (seconds < 60) return `${seconds}s`;
    return `${Math.floor(seconds / 60)}m ${seconds % 60}s`;
  }

  expiryClass(seconds: number): string {
    if (seconds < 0) return 'ka-status--info';
    return seconds < 60 ? 'ka-status--warning' : 'ka-status--success';
  }

  release(item: IUssdSession): void {
    this.$store.dispatch('ussdAdmin/releaseSession', { sessionId: item.sessionId, query: this.query });
  }

  fetchSessions(): void {
    this.$store.dispatch('ussdAdmin/fetchSessions', this.query);
  }

  @Watch('msisdn')
  @Watch('serviceCode')
  onFilterChange(): void {
    this.query = qs.stringify(
      {
        ...(this.msisdn && { msisdn: this.msisdn }),
        ...(this.serviceCode && { serviceCode: this.serviceCode }),
      },
      { skipNulls: true, addQueryPrefix: true },
    );
    this.fetchSessions();
  }

  created(): void {
    this.fetchSessions();
  }
}
